var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tc-tab-bar border-b-2 mb-6"},[_c('div',{staticClass:"flex justify-between max-w-screen-xl mx-auto px-6 overflow-x-scroll md:overflow-x-visible"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }